<template>
  <b-row>
    <b-col>
      <b-card
        style="margin: 0; border: 1px solid #2980b9; padding: 0 10px"
        no-body
        :class="{ open: visibleBody }"
      >
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font: 45px; cursor: pointer"
        >
          <span class="lead collapse-title">
            <strong>ANTECEDENTES PERSONALES </strong>
          </span>

          <i
            :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
          />
        </b-card-header>
        <b-collapse v-model="visibleBody" role="tabpanel">
          <b-card-body style="padding: 1.5rem">
            <b-alert show class="mb-3 p-2">
              <h5 class="mb-1">HISTORIAL</h5>

              <span
                v-if="
                  visibleLastAntPersonales &&
                  visibleLastAntPersonales.length
                "
              >
                <div
                  class="row"
                  v-for="(lastAntPersonal, index) in visibleLastAntPersonales"
                  :key="lastAntPersonal.id"
                >
                  <h6 class="col-3">{{ lastAntPersonal.text }}</h6>
                  <h6 class="col-2">{{ lastAntPersonal.anio }}</h6>
                  <h6 class="col-4">{{ lastAntPersonal.inputText }}</h6>
                  <div class="col-1">
                    <button
                      class="btn btn-warning btn-sm"
                      @click="
                        editarAntecedente(
                          lastAntPersonal.id,
                          lastAntPersonal.value,
                          lastAntPersonal.text
                        )
                      "
                    >
                      <i class="fa-solid fa-pen"></i>
                    </button>
                  </div>
                  <div class="col-1">
                    <button
                      class="btn btn-danger btn-sm"
                      @click="eliminarAntecedente(lastAntPersonal.id)"
                    >
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                  <hr class="col-11 mt-0" />
                </div>
              </span>

              <span
                v-if="
                  !visibleLastAntPersonales.length && !loadingHistorial
                "
              >
                <h4 class="text-center">
                  <i class="fas fa-box-open" />
                  No exite historial
                </h4>
              </span>

              <b-skeleton-wrapper v-if="loadingHistorial">
                <b-skeleton
                  v-for="i in 3"
                  :key="i"
                  width="100%"
                  height="20px"
                />
              </b-skeleton-wrapper>
            </b-alert>

            <div
              class="d-flex justify-content-end mr-2 mb-1"
              v-if="!visibleLastAntPersonales.length"
            >
              <b-form-checkbox v-model="noRefiere" switch>
                <label for="">No Refiere</label>
              </b-form-checkbox>
            </div>

            <div v-if="!noRefiere" class="my-2">
              <hr />

              <div>
                <label for="">Seleccionar antecedentes personales</label>

               

                <v-select
                  class="mb-2"
                  placeholder="Seleccione una o mas opciones"
                  :options="antPersonalesOpts"
                  :reduce="(option) => option"
                  label="text"
                  :multiple="true"
                  v-model="antPersonalesVSelect"
                  @input="
                    (newArray) => (antPersonalesVSelect = onAddNewOpt(newArray))
                  "
                />
              </div>

              <div
                v-for="antPersonal in antPersonalesItems"
                :key="antPersonal.value"
                class="row mb-2"
                v-if="!antPersonal.esHistorial"
              >
                <div class="col-sm-3 d-flex align-items-center">
                  <label>{{ antPersonal.text }}</label>
                </div>

                <div class="col-3">
                  <v-select
                    placeholder="Año"
                    :options="aniosOpts"
                    :reduce="(option) => option"
                    label="text"
                    v-model="antPersonal.anio"
                  />
                </div>

                <div :ref="'scroll-target-' + antPersonal.value">
                  <b-form-input
                    v-model="antPersonal.inputText"
                    :class="{
                      'input-highlight': highlighted === antPersonal.value,
                    }"
                    placeholder="Describa los antecedentes personales..."
                    type="text"
                  />
                </div>
              </div>

              <!-- <div
                v-for="( antPersonal ) in antPersonalesItems"
                :key="antPersonal.value"
                class="row mb-2"
                v-if="!antPersonal.esHistorial"
              >
                <div class="col-sm-3 d-flex align-items-center">
                  <label>{{ antPersonal.text }}</label>
                </div>

                <div class="col-3">
                  <v-select
                    placeholder="Año"
                    :options="aniosOpts"
                    :reduce="option => option"
                    label="text"
                    v-model="antPersonal.anio"
                  />
                </div>
                
                <div class="col-sm-6">
                  <b-form-input 
                    v-model="antPersonal.inputText"
                    placeholder="Describa los antecedentes personales..." 
                    type="text"
                  />
                </div>

              </div> -->

              <!-- <div>
                <b-form-checkbox
                  v-model="observaciones.active"
                >
                  <label for="">Observaciones Adicionales:</label>
                </b-form-checkbox>

                <b-form-textarea
                  v-if="observaciones.active"
                  v-model="observaciones.text"
                />
              </div> -->
            </div>

            <div class="my-3">
              <AntecedentesGinecologicos v-model="summaryTextGineco" />
            </div>
            <!--<div class="my-3">
              <SemiologiaPediatrica />
            </div>

            <div class="my-3">
              <SemiologiaCardiologica />
            </div>
            <div class="my-3">
              <SemiologiaDermatologica />
            </div>
            <div class="my-3">
              <SemiologiaEndocrino />
            </div>
            <div class="my-3">
              <SemiologiaFisiatrica />
            </div>
            <div class="my-3">
              <SemiologiaGastroentereologica />
            </div>
            <div class="my-3">
              <SemiologiaNeumologica />
            </div>
            <div class="my-3">
              <SemiologiaAlergiologica />
            </div>
            <div class="my-3">
              <SemiologiaNutricional />
            </div>
            <div class="my-3">
              <SemiologiaOftalmologica />
            </div>
            <div class="my-3">
              <SemiologiaOncologica />
            </div>
            <div class="my-3">
              <SemiologiaOtorrinolaringologica />
            </div>
            <div class="my-3">
              <SemiologiaUrologica />
            </div>
            <div class="my-3">
              <SemiologiaTraumatologica />
            </div> -->

            <div class="my-2">
              <hr />
              <p v-html="summaryText.html"></p>
              <p v-html="summaryTextGineco.html"></p>
            </div>

            <b-form-group class="mt-1">
              <b-button @click="copyAS400" variant="info">
                AS400 <i class="fas fa-copy"></i>
              </b-button>
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-toast id="my-toast" variant="success" auto-hide-delay="6000" solid>
        <template #toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">Antecedentes personales cargados</strong>
            <small class="text-muted mr-2">Hace 2 segundos</small>
          </div>
        </template>
        Se han cargado los antecedentes personales de la cita anterior de este
        paciente.
      </b-toast>
    </b-col>
  </b-row>
</template>

<script>
import vSelect from "vue-select";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { mapState } from "vuex";
import { addNewOpt, convertToSnakeCase, copyText } from "@/shared/helpers";
import { BToast } from "bootstrap-vue";
import { antPersonalesService } from "../../../atencionCita/services";
import AntecedentesGinecologicos from "./AntecedentesGinecologicos.vue";
import SemiologiaPediatrica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaPediatrica/SemiologiaPediatrica.vue";
import { text } from "@fortawesome/fontawesome-svg-core";
import SemiologiaPsicologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaPsicologica/SemiologiaPsicologica.vue";
import SemiologiaCardiologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaCardiologica/SemiologiaCardiologica.vue";
import SemiologiaDermatologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaDermatologica/SemiologiaDermatologica.vue";
import SemiologiaEndocrino from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaEndocrino/SemiologiaEndocrino.vue";
import SemiologiaFisiatrica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaFisiatrica/SemiologiaFisiatrica.vue";
import SemiologiaGastroentereologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaGastroentereologica/SemiologiaGastroentereologica.vue";
import SemiologiaNeumologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaNeumologica/SemiologiaNeumologica.vue";
import SemiologiaAlergiologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaAlergiologica/SemiologiaAlergiologica.vue";
import SemiologiaNutricional from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaNutricional/SemiologiaNutricional.vue";
import SemiologiaOftalmologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaOftalmologica/SemiologiaOftalmologica.vue";
import SemiologiaOncologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaOncologica/SemiologiaOncologica.vue";
import SemiologiaOtorrinolaringologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaOtorrinolaringologica/SemiologiaOtorrinolaringologica.vue";
import SemiologiaUrologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaUrologica/SemiologiaUrologica.vue";
import SemiologiaTraumatologica from "../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaTraumatologica/SemiologiaTraumatologica.vue";
import { estadosInterconsultas } from "../../../derivaciones/helpers";

export default {
  name: "AntecedentesPersonales",

  components: {
    vSelect,
    BToast,
    AntecedentesGinecologicos,
    SemiologiaPediatrica,
    SemiologiaPsicologica,
    SemiologiaCardiologica,
    SemiologiaDermatologica,
    SemiologiaEndocrino,
    SemiologiaFisiatrica,
    SemiologiaGastroentereologica,
    SemiologiaNeumologica,
    SemiologiaAlergiologica,
    SemiologiaNutricional,
    SemiologiaOftalmologica,
    SemiologiaOncologica,
    SemiologiaOtorrinolaringologica,
    SemiologiaUrologica,
    SemiologiaTraumatologica,
  },

  created() {
    if (!this.isEditar) {
      this.$store.commit("setAntecedentesPersonales", null);
    }
    this.getAntPersonalesOpts();
  },

  props: {
    isEditar: {
      default: false,
      required: false,
    },
    optionsOdontologia: {
      default:null,
      required:null
    }
  },
  data() {
    return {
      isSyncingFromStore: false,
      suppressStoreSync: false,
      highlighted: null,
      lastAntPersonales: [],
      loadingHistorial: false,

      visibleBody: false,
      antPersonalesVSelect: [],
      antPersonalesOpts: [],
      antPersonalesItems: [],
      motivoConsulta: null,

      noRefiere: false,
      observaciones: {
        active: false,
        text: "",
      },

      dataState: {
        noRefiere: false,
        items: [],
        observaciones: {
          active: false,
          text: "",
        },
      },

      summaryTextGineco: { html: "", text: "" },
    };
  },

  methods: {
    isAntPersonalActivo(item) {
      return item?.estado === "1" || item?.estado === 1;
    },

    getAntPersonalKey(item) {
      return item?.id || item?.value || item?.text || item?.inputText;
    },

    dedupeAntPersonales(items = [], { onlyActive = false } = {}) {
      const itemsMap = new Map();

      items.forEach((item) => {
        if (!item) return;
        if (onlyActive && !this.isAntPersonalActivo(item)) return;

        const itemKey = this.getAntPersonalKey(item);
        if (!itemKey) return;

        itemsMap.set(itemKey, { ...item });
      });

      return Array.from(itemsMap.values());
    },

    syncAntPersonalesState() {
      this.dataState.items = this.dedupeAntPersonales(
        [...this.lastAntPersonales, ...this.antPersonalesItems]
      );
    },

    syncEstadoConSeleccion() {
      const seleccionados = this.antPersonalesVSelect.map((item) => item.value);

      // Revisamos lastAntFamiliares
      this.lastAntPersonales.forEach((item) => {
        if (seleccionados.includes(item.value)) {
          item.estado = "1";
        }
      });

      // También para antFamiliaresItems si lo necesitas
      this.antPersonalesItems.forEach((item) => {
        if (seleccionados.includes(item.value)) {
          item.estado = "1";
        }
      });
    },

    editarAntecedente(id, value, text) {
      this.visibleBody = true;
      // Verificar si el elemento ya existe en el arreglo
      const itemExistente = this.antPersonalesVSelect.find(
        (item) => item.id === id
      );

      // Si no existe, agregarlo
      if (!itemExistente) {
        this.antPersonalesVSelect.push({ id, value, text });
      }

      // Esperar a que se actualice antPersonalesItems y se renderice el DOM
      this.$nextTick(() => {
        // Esperar una segunda vez por seguridad
        this.$nextTick(() => {
          const el = this.$refs["scroll-target-" + value];
          if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
            const input = el.querySelector("input");
            if (input) input.focus();
          } else {
            console.warn("No se encontró el elemento para scroll:", el);
          }
        });
      });
    },

    eliminarAntecedente(id) {
      this.lastAntPersonales.forEach((item) => {
        if (item.id === id) {
          item.estado = "0";
        }
      });

      this.antPersonalesVSelect = this.antPersonalesVSelect.filter(
        (item) => item.id !== id
      );

      //this.lastAntPersonales = this.lastAntPersonales.filter(item => item.estado === '1');
    },
    getLastAnio(id) {
      const matchedItem = this.lastAntPersonales.filter(
        (last) => last.id === id
      );
      if (matchedItem && matchedItem.length > 0) {
        return matchedItem[0].anio;
      }

      return "";
    },

    getLastInputText(id) {
      const matchedItem = this.lastAntPersonales.filter(
        (last) => last.id === id
      );
      if (matchedItem && matchedItem.length > 0) {
        return matchedItem[0].inputText;
      }
      return "";
    },

    async fetchHistorialAntPersonales(idPaciente) {
      this.loadingHistorial = true;

      if (this.isEditar) {
        this.applyAntPersonalesFromStore(this.stAntPersonales);
        this.loadingHistorial = false;
      } else {
        const historialAP = await antPersonalesService.getAllByPaciente(
          idPaciente
        );
        this.loadingHistorial = false;
        if (!historialAP.length) return;
        const ultimoValido = historialAP.find(
          (a) => a.descripcionGeneral !== "No refiere"
        );
        if (!ultimoValido) return;
        const idAtencionUltimoValido = ultimoValido.consultamedica.id;
        let searchByAtencion = historialAP.filter(
          (a) => a.consultamedica.id === idAtencionUltimoValido
        );
        if (!searchByAtencion.length) return;
        this.lastAntPersonales = this.dedupeAntPersonales(
          searchByAtencion.map((item) => ({
            id: item.antescedentesPersonales.id,
            text: item.antescedentesPersonales.descripcion,
            anio: item.anio,
            estado: item.estado,
            value: convertToSnakeCase(item.antescedentesPersonales.descripcion),
            inputText: item.descripcionGeneral,
            esHistorial: true,
          })),
          { onlyActive: true }
        );
      }
    },

    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    async getAntPersonalesOpts() {
      const query = `
        query {
          allAnteper {
            id, descripcion
          }
        }
      `;
      try {
        const response = await axios.post(`${rutas.axios}api`, { query });

        this.antPersonalesOpts = response.data.data.allAnteper.map((item) => ({
          id: item.id,
          text: item.descripcion,
          value: convertToSnakeCase(item.descripcion),
        }));
      } catch (error) {
        console.error("Error fetching antecedentes personales:", error);
      }
    },

    copyAS400() {
      copyText(`${this.summaryText.text}${this.summaryTextGineco?.text}`);
    },

    applyAntPersonalesFromStore(data) {
      if (!data) return;

      const items = Array.isArray(data.items) ? data.items : [];

      this.isSyncingFromStore = true;

      this.noRefiere = !!data.noRefiere;
      this.observaciones = data.observaciones
        ? { ...data.observaciones }
        : { active: false, text: "" };

      this.lastAntPersonales = this.dedupeAntPersonales(
        items.map((item) => ({
          ...item,
          esHistorial: true,
        }))
      );

      this.antPersonalesVSelect = items.map((item) => ({
        id: item.id,
        value: item.value,
        text: item.text,
      }));

      this.antPersonalesItems = this.dedupeAntPersonales(
        items.map((item) => ({
          ...item,
          estado: item.estado || "1",
        }))
      );

      this.$nextTick(() => {
        this.isSyncingFromStore = false;
      });
    },
  },
  

  watch: {
    optionsOdontologia: {
      deep:true,
      immediate:true,
      handler(newValue){
        if(newValue){
          this.antPersonalesOpts = [...newValue]
        }
      }
    },
   antPersonalesVSelect: {
  deep: true,
  handler(newArray) {
    // 💡 Verificar que optionsOdontologia existe y no está vacía
    if (this.optionsOdontologia?.length) {
      // 💡 Revisar si alguna opción seleccionada está en optionsOdontologia
      const contieneDeOdontologia = newArray.some((sel) =>
        this.optionsOdontologia.some(
          (opt) => opt.value === sel.value || opt.id === sel.id
        )
      );

      // ✅ Si se cumple ambas condiciones, procesar con onAddNewOpt()
      if (contieneDeOdontologia) {
        newArray = this.onAddNewOpt(newArray);
      }
    }

    const idAntPersonales = newArray.map((item) => item.value);

    const nuevosItems = idAntPersonales.map((id) => {
      const existente = this.antPersonalesItems.find((item) => item.value === id);
      const existenteLastIems = this.lastAntPersonales.find((item) => item.value === id);
      const nuevo = newArray.find((item) => item.value === id);

      let existente_anio = existente?.anio || existenteLastIems?.anio || this.getLastAnio(nuevo?.id);
      let existente_inputText = existente?.inputText || existenteLastIems?.inputText || this.getLastInputText(nuevo?.id);

      return {
        id: nuevo?.id || null,
        value: id,
        text: nuevo?.text || "",
        estado: "1",
        anio: existente_anio,
        inputText: existente_inputText,
      };
    });

    this.antPersonalesItems = this.dedupeAntPersonales(nuevosItems);
    this.syncEstadoConSeleccion();
  },
},


    idPaciente: {
      deep: true,
      handler(newValue) {
        this.fetchHistorialAntPersonales(newValue);
      },
    },

    antPersonalesItems: {
      deep: true,
      handler() {
        this.syncAntPersonalesState();
      },
    },

    // antPersonalesItems: {
    //   deep: true,
    //   handler(newValue) {
    //     this.dataState.items = [...this.lastAntPersonales, ...newValue];
    //   }
    // },

    lastAntPersonales: {
      deep: true,
      handler(newValue) {
        if (!newValue.length) return;
        this.noRefiere = false;
        this.syncAntPersonalesState();
      },
    },

    observaciones: {
      deep: true,
      handler(newValue) {
        this.dataState.observaciones = newValue;
        if (!newValue.active) this.observaciones.text = "";
      },
    },

    summaryText: {
      deep: true,
      handler(newValue) {
        this.dataState.text = newValue.text;
      },
    },

    noRefiere: {
      deep: true,
      handler() {
        if (this.noRefiere === true) {
          this.antPersonalesItems = [];
          this.antPersonalesVSelect = [];
          this.observaciones = { active: false, text: "" };
        }
        this.dataState.noRefiere = this.noRefiere;
      },
    },

    dataState: {
      deep: true,
      handler(newValue) {
        if (this.isSyncingFromStore) return;
        this.suppressStoreSync = true;
        this.$store.commit("setAntecedentesPersonales", newValue);
        this.$nextTick(() => {
          this.suppressStoreSync = false;
        });
      },
    },

    stAntPersonales: {
      deep: true,
      handler(newValue) {
        if (!this.isEditar) return;
        if (this.suppressStoreSync) return;
        if (!newValue?.items?.length && !newValue?.noRefiere) return;
        this.applyAntPersonalesFromStore(newValue);
      },
    },
  },

  computed: {
    ...mapState({
      stAntPersonales: (state) =>
        state.atencionCita?.anamnesis.antecedentesPersonales,
      stSemiologias: (state) => state.atencionCita?.semiologias,
      stDataCita: (state) => state.atencionCita?.dataCita,
    }),

    idPaciente() {
      return this.stDataCita?.paciente?.id;
    },

    visibleLastAntPersonales() {
      return this.dedupeAntPersonales(this.lastAntPersonales, {
        onlyActive: true,
      });
    },

    summaryText() {
      if (this.noRefiere) return { html: "No refiere", text: "No refiere" };
      const filteredItemsEstado = this.antPersonalesItems.filter(
        (item) => item.estado === "1" || item.estado === 1
      );
      const filteredItems = filteredItemsEstado.filter(
        (item) => item.inputText.trim() !== ""
      );
      const textArray = filteredItems.map(
        (item) =>
          `${item.text}: ${item.anio ? `(${item.anio})` : ""} ${item.inputText}`
      );
      if (this.lastAntPersonales.length) {
        this.lastAntPersonales.forEach((item) => {
          const antecedente = `${item.text}: ${
            item.anio ? `(${item.anio})` : ""
          } ${item.inputText}`;

          if (this.antPersonalesItems.find((act) => act.value === item.value)) {
          } else {
            if (item.estado === "1") {
              textArray.unshift(antecedente);
            }
          }
        });
      }

      if (this.observaciones.active && this.observaciones.text.trim() !== "") {
        textArray.push(`Observaciones adicionales: ${this.observaciones.text}`);
      }

      const codEspDoc = this.stDataCita?.doctor?.especialidad?.codEsp;

      // let semiologia = "";
      // if (codEspDoc === "0000000107") {
      //   const semPediatrica = this.stSemiologias.semPediatrica;

      //   const prenatales = semPediatrica.prenatales
      //     ? `
      //   <br>
      //   Edad Madre : ${semPediatrica.prenatales.edadMadre || ""}
       
      //   `
      //     : "";

      //   semiologia = `Antecedentes Pediatricos: <br> 
      //   Rango edad: ${this.stSemiologias.semPediatrica?.rango_edad || ""} <br>
      //   <b> Prenatales: </b> ${prenatales} <br>
      //   Natales: ${this.stSemiologias.semPediatrica?.natales || ""} <br>
      //   Postnatales: ${this.stSemiologias.semPediatrica?.postnatales || ""} <br>
      //   Aeipi: ${this.stSemiologias.semPediatrica?.aeipi || ""} <br>
      //   `;
      // }
      // textArray.push(semiologia);

      const textFinish = {
        html: textArray.join("<br>"),
        text: `\nAntecedentes Personales:\n` + textArray.join("\n"),
      };

      return textFinish;
    },

    aniosOpts() {
      const currentYear = new Date().getFullYear();
      const years = Array.from(
        { length: 70 },
        (_, index) => currentYear - index
      );
      return years;
    },
  },
};
</script>

<style scoped>
.input-highlight {
  animation: highlight-fade 2s ease;
  border: 2px solid #3498db !important;
  border-radius: 4px;
}

@keyframes highlight-fade {
  0% {
    background-color: #d6ecff;
  }

  100% {
    background-color: transparent;
  }
}
</style>
